module.exports = __webpack_public_path__ + "img/valores-ouvir.09f728dc.svg";